class HeaderColumnMenu extends HTMLElement {
	connectedCallback() {
		this.details = this.querySelector('details');
		this.trigger = this.querySelector('summary');
		this.panel = this.querySelector('.header-column-menu__panel');
		this.events = new AbortController();
		const options = { signal: this.events.signal };
		this.desktop = window.matchMedia('(min-width: 1100px)');

		this.addEventListener('pointerenter', (event) => {
			if (event.pointerType !== 'mouse' || !this.desktop.matches) return;
			clearTimeout(this.closeTimer);
			if (!this.details.open) {
				this.open();
				this.openedOnHover = true;
			}
		}, options);
		this.trigger.addEventListener('click', (event) => {
			if (event.detail > 0 && this.details.open && this.openedOnHover) {
				event.preventDefault();
			}
			this.openedOnHover = false;
		}, options);
		this.addEventListener('pointerleave', (event) => {
			if (event.pointerType !== 'mouse') return;
			this.closeTimer = setTimeout(() => {
				if (!this.contains(document.activeElement)) this.close();
			}, 150);
		}, options);
		this.details.addEventListener('toggle', () => {
			this.trigger.setAttribute('aria-expanded', String(this.details.open));
			if (this.details.open) {
				this.closeSiblings();
				this.updatePanelHeight();
			}
		}, options);
		window.addEventListener('resize', () => {
			if (this.details.open) this.updatePanelHeight();
		}, options);
		this.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && this.details.open) {
				event.preventDefault();
				event.stopPropagation();
				this.close();
				this.trigger.focus();
			} else if (event.key === 'ArrowDown' && event.target === this.trigger) {
				event.preventDefault();
				this.open();
				this.querySelector('.header-column-menu__panel a')?.focus();
			}
		}, options);
		this.addEventListener('focusout', (event) => {
			if (!this.contains(event.relatedTarget)) this.close();
		}, options);
		document.addEventListener('pointerdown', (event) => {
			if (!this.contains(event.target)) this.close();
		}, options);
		this.desktop.addEventListener('change', () => this.close(), options);
		this.closest('.shopify-section').addEventListener('shopify:block:select', (event) => {
			if (this.contains(event.target)) this.open();
		}, options);
		this.closest('.shopify-section').addEventListener('shopify:block:deselect', () => this.close(), options);
		this.trigger.setAttribute('aria-expanded', String(this.details.open));
	}

	open() {
		this.closeSiblings();
		this.details.open = true;
		this.trigger.setAttribute('aria-expanded', 'true');
		this.updatePanelHeight();
	}

	updatePanelHeight() {
		this.panel.style.setProperty('--menu-available-height', `${Math.max(0, window.innerHeight - this.panel.getBoundingClientRect().top - 16)}px`);
	}

	closeSiblings() {
		this.closest('nav').querySelectorAll('header-column-menu').forEach((menu) => {
			if (menu !== this) menu.close();
		});
	}

	close() {
		clearTimeout(this.closeTimer);
		this.openedOnHover = false;
		this.details.open = false;
		this.trigger.setAttribute('aria-expanded', 'false');
	}

	disconnectedCallback() {
		clearTimeout(this.closeTimer);
		this.events.abort();
	}
}

if (!customElements.get('header-column-menu')) {
	customElements.define('header-column-menu', HeaderColumnMenu);
}
